<template>
	<div @click="clickIcon" :class="{active: isActive, 'no-active': !autoSetActive}" v-html="finalIcon"></div>
</template>

<script>
import {useSvgStore} from "@/shared/stores";

export default {
	setup() {
		const svgStore = useSvgStore();
		return {
			getIcon: svgStore.get,
		};
	},
	emits: ["click-icon"],
	name: "AppClickableIcon",
	data() {
		return {
			isActive: this.active
		};
	},
	props: {
		iconName: {type: String, required: true},
		active: {type: Boolean, default: false},
		autoSetActive: {type: Boolean, default: true},
	},
	computed: {
		finalIcon() {
			return this.getIcon(this.iconName);
		}
	},
	methods: {
		clickIcon() {
			if(this.autoSetActive) { this.isActive = !this.isActive; }
			this.$emit("click-icon", this.isActive);
		}
	},
	watch: {
		active(newValue) {
			this.isActive = newValue;
		}
	}
}
</script>

<style lang="scss" scoped>
div {
	height: 15px;
	width: 15px;

	&:deep(svg) {
		height: 100%;
		width: 100%;
		cursor: pointer;

		&, & * {
			@include noSelect;
		}

		& * {
			pointer-events: none;
			transition: fill .2s $transition;
		}

		path.fill {
			fill: $txt_2;
		}

		&:hover path.fill {
			fill: $txt_0;
		}

		&:active path.fill {
			fill: $secondary;
		}

		path.stroke {
			stroke: $txt_2;
		}

		&:hover path.stroke {
			stroke: $txt_0;
		}

		&:active path.stroke {
			stroke: $secondary;
		}

		rect.fill {
			fill: $txt_2;
		}

		&:hover rect.fill {
			fill: $txt_0;
		}

		&:active rect.fill {
			fill: $secondary;
		}

		rect.stroke {
			stroke: $txt_2;
		}

		&:hover rect.stroke {
			stroke: $txt_0;
		}

		&:active rect.stroke {
			stroke: $secondary;
		}
	}

	&.no-active:deep(svg):active {
		path.fill { fill: $txt_0; }
		path.stroke { stroke: $txt_0; }
		rect.fill { fill: $txt_0; }
		rect.stroke { stroke: $txt_0; }
	}

	&.active:deep(svg path.fill) {
		fill: $secondary;
	}

	&.active:deep(svg path.stroke) {
		stroke: $secondary;
	}

	&.active:deep(svg rect.fill) {
		fill: $secondary;
	}

	&.active:deep(svg rect.stroke) {
		stroke: $secondary;
	}
}
</style>